export default __webpack_public_path__ + "static/media/SPECTRAL ZIP-ZAP.28a73a9d.jpg";